import React, { useLayoutEffect } from 'react';
import { Creator } from './creator/Creator';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { UUID } from '@/types/types';
import { useMutation } from '@tanstack/react-query';
import { setLoading } from '@/store/slices/appSlice';
import PresetApi from '@/api/PresetApi';

const url = new URL(window.location.href);
const searchParams = new URLSearchParams(url.search);

export const isDev = !!searchParams.get('DEV') || import.meta.env.DEV;
export const isPresetMode = !!searchParams.get('presetMode');
export const presetId = searchParams.get('preset');

const App: React.FC = () => {
	const dispatch = useTypedDispatch();

	const { options } = useTypedSelector((app) => app.creator);

	const loadPresetMutation = useMutation({
		mutationFn: PresetApi.mutationGetOne,
		onSuccess: (preset) => {
			dispatch(creatorActions.loadPreset(preset));
			dispatch(setLoading(false));
		},
	});

	useLayoutEffect(() => {
		if (isPresetMode) {
			if (presetId) {
				dispatch(setLoading(true));
				loadPresetMutation.mutate(presetId as UUID);
			} else
				dispatch(
					creatorActions.updateOptions({
						isPresetMode,
					})
				);
			return;
		}

		if (presetId)
			dispatch(
				creatorActions.updateOptions({
					lockedPresetId: presetId as UUID,
				})
			);
	}, []);

	return <Creator />;
};

export default App;
